import { NavigateFunction, To } from 'react-router-dom';
import { toast } from 'react-toastify';

import { WarningMessage } from '@shared/components/Toast/WarningMessage/WarningMessage';

export const navigateTo = (
  navigate: NavigateFunction,
  to: string | To,
  options?: {
    warningMessage?: string;
    errorMessage?: string;
    state?: unknown;
  },
): Promise<void> => {
  const navigationOptions = options?.state !== undefined ? { state: options.state } : undefined;
  const navigationResult = navigationOptions ? navigate(to, navigationOptions) : navigate(to);

  const handleWarning = () => {
    if (options?.warningMessage) {
      toast.warning(<WarningMessage message={options.warningMessage} />);
    }
  };

  const handleError = () => {
    if (options?.errorMessage) {
      toast.error(<WarningMessage message={options.errorMessage} />);
    }
  };

  if (navigationResult instanceof Promise) {
    return navigationResult.then(handleWarning).catch(handleError);
  } else {
    handleWarning();
    return Promise.resolve();
  }
};
